class SuperSearchCart {
  constructor() {
    this.cartTrigger = document.querySelector('.js-cart-drawer-trigger');
    this.superSearch = document.querySelector('.super-search');
    this.cartDrawer = document.querySelector('cart-drawer');
    
    if (this.cartTrigger && this.superSearch && this.cartDrawer) {
      this.init();
    }
  }

  init() {
    this.cartTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      const rootHtml = document.getElementsByTagName("html")[0];
      
      // Cerrar el super-search
      this.superSearch.classList.add('hidden-with-animation');
      this.superSearch.classList.remove("show");
      document.body.classList.remove("overflow-hidden");
      rootHtml.classList.remove("overflow-hidden");
      document.body.querySelector(".overlay").classList.remove("is-visible");
      
      // Esperar a que se cierre el super-search antes de abrir el cart-drawer
      setTimeout(() => {
        // Abrir el cart-drawer
        this.cartDrawer.open();
      }, 300); // 300ms es el tiempo de la animación del super-search
    });
  }
}

// Inicializar cuando el DOM esté listo
customElements.define('super-search-cart', class extends HTMLElement {
  connectedCallback() {
    new SuperSearchCart();
  }
});